import type { FaireProductEntity } from "../../entity_types/product";

export const p_qqfntsnzwk: FaireProductEntity = {
  token: "p_qqfntsnzwk",
  type: "product",
  name: "El Chilito Hot sauce 10 oz. Case",
  brandToken: "b_8b9cxhr4de",
  brandName: "El Chilito Hot Sauce",
  imageUrl:
    "https://cdn.faire.com/fastly/9b26923298cd73b4ae7a1205dd1ad75593f4a0e2b8a9fd8833fe1a839bf167c2.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9ee88f65cb261d8d06c6361b01881cbca18f94be426207a43e9addb916668e61.png",
    "https://cdn.faire.com/fastly/94d0903446105871431cff1737d2e9450a3c9882893995394898ebf981f00cde.png",
    "https://cdn.faire.com/fastly/e3190b2b0b0318effb641b212f49264b2b2b76994a5a0af919acc71816d6b285.png",
  ],
  priceDollars: 8,
  description:
    "El Chilito hot sauce made with amor y sabor, from our family to yours. Three generations of flavor and tradition. We hope you enjoy with all your favorite foods! \n\nFamily-owned, small batched and bottled in Los Angeles, CA. \n\nMade with LOVE, Distilled Vinegar, Pineapple Juice, Chili Pepper, Piloncillo, Garlic, Salt, Spices and Sesame Seed. ",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:16:56.380Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
